module.exports = __webpack_public_path__ + "img/margaret.517ef8c2.webp";